import { memo } from 'react';

import { EyeClosedIcon, EyeIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { useShowUI2Page } from '~/components/v2/hooks/useShowUI2Page';
import { useToggleNestedItems } from '~/hooks/search/useToggleNestedItems';

export const ToggleNestedItemsButton = memo(() => {
  const { isFlattenedView, toggleNestedItems } = useToggleNestedItems();
  const { showUI2 } = useShowUI2Page();

  return (
    <Button
      appearance="ghost"
      color={isFlattenedView ? 'blue' : 'grey'}
      data-testid="TOGGLE_NESTED_ITEMS_BUTTON"
      prefix={isFlattenedView ? <EyeClosedIcon size="sm" /> : <EyeIcon size="sm" />}
      onClick={toggleNestedItems}
      size={showUI2 ? 'small' : 'medium'}
    >
      {isFlattenedView ? 'Collapse nested content' : 'Expand nested content'}
    </Button>
  );
});

ToggleNestedItemsButton.displayName = 'ToggleNestedItemsButton';
